export type ApiAuth = {
    tokenFetcher?: () => Promise<string>
}

export const ApiAuth: ApiAuth = {
    tokenFetcher: undefined,
};
